import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FormsLayer from "../components/FormsLayer";

const FormBuilderPage = () => (
  <MasterLayout pageTitle="Form Builder">
    <FormsLayer />
  </MasterLayout>
);

export default FormBuilderPage;
